import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Button, } from "react-bootstrap";
import DefaultGrid from "../Default/DefaultGrid";
import { useFilters } from "../Filters/UseFilter";

interface ModalProps {
  dataGrid: any;
  setDataGrid: any;
  setData: any;
  setDataSearch: any;
  searchFor: any
}

const GridModelosProduto: React.FC<ModalProps> = ({ dataGrid, setDataGrid, setData, setDataSearch, searchFor }) => {
  const { filters, handleFilterChange } = useFilters([]);

  const columns = [
    {
      key: "", render: (item: any) => (
        <span className=" d-flex justify-content-center align-items-center ">
          <Button size="sm" className="col-12" onClick={() => selectModelos(item)} variant="secondary"><FontAwesomeIcon icon={faCheck} /></Button>
        </span>

      ), label: <Button size="sm" className="col-12" disabled variant="secondary"><FontAwesomeIcon icon={faCheck} /></Button>
    },
    { key: "modelo", label: "MODELO" },
    { key: "descricao", label: "DESCRIÇÃO" },
    { key: "grupo", label: "GRUPO" },
    { key: "genero", label: "GENERO" },
    { key: "cor", label: "COR" },
  ]


  const selectModelos = (item: any) => {
    setData(item)
    setDataSearch((prevData: any) => ({
      ...prevData,
      searchValue: item[searchFor],
    }))
    setDataGrid([])
  }

  return (
    <DefaultGrid
      columns={columns}
      filters={filters}
      handleFilterChange={handleFilterChange}
      items={dataGrid}
    />
  );
};

export default GridModelosProduto;
